import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { VisitorEntities } from 'client/data/models/visitor';
import { LOAN_PAYMENT } from 'site-modules/shared/constants/allowed-inventory-request-params';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { UsurpInventoryCard } from 'site-modules/shared/components/inventory/usurp-inventory-card/usurp-inventory-card';
import { CardCompareSelect } from 'site-modules/shared/components/profile/card-compare-select/card-compare-select';

export function RecentlyViewedCard({ vinData, compareSelect = null, visitorLocation = null, isMobile = false }) {
  const { priceDrop, hasNewAlert } = vinData;

  const {
    vehicleInfo: {
      styleInfo: { year, make, model, trim },
    },
  } = vinData;
  const ariaLabel = `Compare ${year} ${make} ${model} ${trim}`;

  return (
    <div className="recently-viewed-card pos-r d-flex flex-column justify-content-between rounded h-100 mb-1">
      <UsurpInventoryCard
        vehicle={vinData}
        isMobile={isMobile}
        visitorLocation={visitorLocation}
        grayIcons
        isDealerSrp
        paymentType={LOAN_PAYMENT} // to skip paymenttype in vdp link
        radius={0} // to skip radius in vdp link
        isSimilarCards
        showCtaButton={false}
        showInventoryHeart={false}
        showInventoryBadge={false}
      />
      {compareSelect && (
        <CardCompareSelect vinData={vinData} compareSelect={compareSelect} isBottomSkipLink ariaLabel={ariaLabel} />
      )}
      {!!priceDrop && (
        <div className="pos-a left-0 top-0 w-100 pt-0_5 px-0_5 overlay-top">
          <span
            className={classnames('rounded p-0_25 bg-white size-12', {
              'text-primary-darker': hasNewAlert,
              'text-gray-darker': !hasNewAlert,
            })}
          >
            <span className="icon-arrow-down8 size-10 me-0_25" aria-hidden />
            Price drop {formatPriceString(Math.floor(priceDrop))}
          </span>
        </div>
      )}
    </div>
  );
}

RecentlyViewedCard.propTypes = {
  vinData: PropTypes.shape({}).isRequired,
  compareSelect: PropTypes.shape({}),
  visitorLocation: VisitorEntities.Location,
  isMobile: PropTypes.bool,
};
